export default __webpack_public_path__ + "static/lframe-pay-any-way-10f1d2bc3b03a7adc01ee02ef9e63150.png";